import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";

import { AteneaModule } from "@atenea-cms";
import { AteneaBrandModule } from "@atenea-cms-brand";
import { AppComponent } from "./app.component";
import { config } from "../config";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AteneaModule.forRoot(config),
    AteneaBrandModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./apps/nox/src/app/app.module.ts